import { useAuth } from '@/context/appContext';
// project import
import { useMenuBar } from '@/services/MenuBarService';
// types
import { NavItemType } from '@/types/menu';

import { navItemCheckAuth } from './index';
import NavCollapse from './NavCollapse';
import { NavItem } from './NavItem';

// ==============================|| NAVIGATION - LIST GROUP ||============================== //

interface Props {
  item: NavItemType;
}

const NavGroup = ({ item }: Props) => {
  const { hasAuth } = useAuth();

  const drawerOpen = useMenuBar(state => state.drawerOpen);

  const navCollapse = item.children?.map(menuItem => {
    switch (menuItem.type) {
      case 'collapse':
        return <NavCollapse key={menuItem.id} menu={menuItem} level={1} />;
      case 'item':
        return <NavItem key={menuItem.id} item={menuItem} level={1} />;
      default:
        return (
          <p key={menuItem.id} className="px-3 py-2 text-center text-xs text-critical">
            Fix - Group Collapse or Items
          </p>
        );
    }
  });

  if (!navItemCheckAuth(item, hasAuth)) {
    return null;
  }

  return (
    <div className={drawerOpen && item.title ? 'mt-5' : ''}>
      {item.title && drawerOpen && (
        <div className="mb-1.5 px-3">
          <p className="m-0 text-caption font-semibold uppercase tracking-eyebrow text-sidebar-ink-muted">
            {item.title}
          </p>
          {item.caption && <p className="m-0 mt-1 text-caption text-sidebar-ink-muted">{item.caption}</p>}
        </div>
      )}
      <div className="relative z-0 flex flex-col gap-0.5">{navCollapse}</div>
    </div>
  );
};

export default NavGroup;
